import { CircularProgress } from '@mui/material';
import { BreadcrumbsNavigation, Container } from 'common/components';
import { CircularProgressWrapper } from 'globalStyles';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchReportsSchema } from 'store/actions/advocacyReports';
import { campaignsSelectors } from 'store/selectors/campaigns';
import styled from 'styled-components';
import Grid from '../../../material/components/Grid';
import ActionCenterAnalyticsReport from '../components/ActionCenterAnaliticsReport';
import ActionCenterMessagesReports from '../components/ActionCenterMessagesReports';
import CampaignAnalyticsReport from '../components/CampaignAnalyticsReport';
import CampaignMessagesReport from '../components/CampaignMessagesReport';
import CampaignReportsTopCard from '../components/CampaignReportsTopCard';
import OrganizationAdvocacyReport from '../components/OrganizationAdvocacyReport';
import { SectionTitle } from '../components/styles';

const ReportSectionWrapper = styled.div`
  margin-bottom: 16px;
  border-radius: 8px;
  padding: 24px;
  background-color: #fff;
`;

const CampaignReports = () => {
  const { campaignUuid, organizationUuid } = useParams();
  const dispatch = useDispatch();

  const { campaignReportsSchema, isCampaignReportsSchemaFetching } = useSelector(state => ({
    campaignReportsSchema: campaignsSelectors.getCampaignReportsSchema(state),
    isCampaignReportsSchemaFetching: campaignsSelectors.isCampaignReportsSchemaFetching(state),
  }));

  useEffect(() => {
    dispatch(fetchReportsSchema(organizationUuid));
  }, [dispatch, campaignUuid, organizationUuid]);

  if (isCampaignReportsSchemaFetching || !campaignReportsSchema) {
    return (
      <CircularProgressWrapper>
        <CircularProgress />
      </CircularProgressWrapper>
    );
  }

  const breadcrumbs = [
    {
      link: `/${organizationUuid}/campaigns`,
      name: 'Advocacy',
    },
    {
      name: 'Reports',
    },
  ];

  return (
    <>
      <BreadcrumbsNavigation links={breadcrumbs} />
      <Container marginBottom="40">
        <Grid container>
          <CampaignReportsTopCard
            title="Advocacy reports"
            backButtonLink={`/${organizationUuid}/campaigns/`}
          />
        </Grid>
        <ReportSectionWrapper>
          <SectionTitle variant="body2">Action Center Reports</SectionTitle>
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 6,
                xs: 12,
              }}
            >
              <ActionCenterMessagesReports
                organizationUuid={organizationUuid}
                reportsSchema={campaignReportsSchema}
              />
            </Grid>
            <Grid
              size={{
                md: 6,
                xs: 12,
              }}
            >
              <ActionCenterAnalyticsReport
                organizationUuid={organizationUuid}
                reportsSchema={campaignReportsSchema}
              />
            </Grid>
          </Grid>
        </ReportSectionWrapper>
        <ReportSectionWrapper>
          <SectionTitle variant="body2">Campaign Reports</SectionTitle>
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 6,
                xs: 12,
              }}
            >
              <CampaignMessagesReport
                organizationUuid={organizationUuid}
                reportsSchema={campaignReportsSchema}
              />
            </Grid>
            <Grid
              size={{
                md: 6,
                xs: 12,
              }}
            >
              <CampaignAnalyticsReport
                organizationUuid={organizationUuid}
                reportsSchema={campaignReportsSchema}
              />
            </Grid>
          </Grid>
        </ReportSectionWrapper>
        <ReportSectionWrapper>
          <SectionTitle variant="body2">Organization</SectionTitle>
          <Grid container spacing={3}>
            <Grid
              size={{
                md: 6,
                xs: 12,
              }}
            >
              <OrganizationAdvocacyReport organizationUuid={organizationUuid} />
            </Grid>
          </Grid>
        </ReportSectionWrapper>
      </Container>
    </>
  );
};

export default CampaignReports;
